import {
  Avatar,
  Col,
  Flex,
  Input,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../../common/spinner/Spinner";
import { getPayrollAction } from "../../../../../../redux/services/payroll/payrollServices";
import { colors } from "../../../../../../constants/colors";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import { SearchOutlined } from "@ant-design/icons";
import { UserOutlined } from "@ant-design/icons";
import styles from "./Revenue.module.scss";

const Revenue = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { payroll } = useSelector((state) => state.payroll);
  const [searchValue, setSearchValue] = useState("");
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: payroll?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue,
    };
    dispatch(getPayrollAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Provider.serviceProviderId"),
        dataIndex: "organization_number",
        key: "organization_number",
        render: (_, record) => (
          <p>{record?.organization?.organization_number}</p>
        ),
      },
      {
        title: t("Modules.Provider.serviceProviderName"),
        key: "name",
        render: (_, record) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar
                size="large"
                src={record?.organization?.logo_image}
                key={record?.organization?._id}
                icon={<UserOutlined />}
              />
              {`${record?.organization?.name || "-"}`}
            </Flex>
          );
        },
      },
      {
        title: t("appointmentInfo.directorName"),
        key: "name",
        render: (_, record) => {
          return <>{record?.organization?.director_name || "-"}</>;
        },
      },
      {
        title: t("ProfileSetup.branchLabel"),
        dataIndex: "branch",
        key: "branch",
        render: (_, record) => <p>{record?.organization?.branch || "-"}</p>,
      },
      {
        title: t("revnue.revenue"),
        dataIndex: "total_revenue",
        key: "total_revenue",
        render: (_, record) => (
          <p>{record?.total_revenue ? record?.total_revenue?.toFixed(2) : "-"}</p>
        ),
      },
      {
        title: t("revenueShare"),
        dataIndex: "organization_revenue_share",
        key: "organization_revenue_share",
        render: (_, record) => (
          <p>{record?.organization_revenue_share ? record?.organization_revenue_share?.toFixed(2) : "-"}</p>
        ),
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  background:
                    record?.status === "PAID"
                      ? colors.lightTeal
                      : colors.lightPinkishRed,
                  color:
                    record?.status === "PAID"
                      ? colors.darkTeal
                      : colors.darkMaroon,
                }}
              >
                {record?.status}
              </Tag>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleViewDetails = (e, row) => {};

  return (
    <div className={styles.userContainer}>
      <Flex vertical gap="2rem">
        <Row gutter={[16, 16]}>
          <Col span={8} style={{ display: "flex", alignItems: "center" }}>
            <Input
              size="large"
              suffix={<SearchOutlined />}
              placeholder={t("CommonUtils.searchByName")}
              onChange={(event) => setSearchValue(event.target.value)}
            />
          </Col>
        </Row>
        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={payroll?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default Revenue;
